import React from 'react';


var pjson = require('../../../../package.json')

const Footer = () => {
    return (
        <div className={"text-center"}>


            <footer className="app-footer">
            <span className="d-inline-block">&copy; 2018-2024 BreachBits, Inc.</span>
            {/*<span className="d-inline-block"><IntlMessages id="legal.confidential.short"/></span>*/}
            <span id={"version"}>v{`${pjson.version}`}</span>
            {/*<Button*/}
            {/*  href="https://codecanyon.net/cart/configure_before_adding/20978545?license=regular&ref=phpbits&size=source&support=bundle_12month&_ga=2.172338659.1340179557.1515677375-467259501.1481606413"*/}
            {/*  target="_blank"*/}
            {/*  size="small"*/}
            {/*  color="primary"*/}
            {/*><IntlMessages id="eCommerce.buyNow"/></Button>*/}
        </footer>
        </div>

    );
  }
;

export default Footer;
